export default {"src":"/_next/static/media/ada.7ee9b2b6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};